import { FormEvent, useState } from 'react';

import { urls } from '@zapier/identity-utils';
import { fetch } from '../../../utils';

export type ForgotPasswordStatus = 'initial' | 'submitting' | 'success';

async function submitForgotPassword(email: string) {
  const resp = await fetch(urls.FORGOT_PASSWORD_API_URL, {
    method: 'POST',
    body: { email },
  });

  if (resp.status === 200) {
    // Yay! Success
    return '';
  } else if (resp.status === 403) {
    return 'Account is disabled, contact support.';
  } else if (resp.status === 404) {
    return 'No users exist with that email.';
  } else if (resp.status == 429) {
    return 'You’re trying too frequently.';
  }

  // Unknown error
  return 'Yikes! Something went wrong. If you keep having trouble, please contact support.';
}

export function useForgotPassword() {
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string | undefined>();
  const [status, setStatus] = useState<ForgotPasswordStatus>('initial');

  async function handleSubmit(e?: FormEvent<HTMLFormElement>) {
    if (e) {
      e.preventDefault();
    }

    setStatus('submitting');
    setError(undefined);

    const error = await submitForgotPassword(email);

    setError(error);
    setStatus(error ? 'initial' : 'success');
  }

  function handleChangeEmail(value: string) {
    setEmail(value);
  }

  return {
    canSubmit: email.length > 0 && status !== 'submitting',
    email,
    error,
    handleChangeEmail,
    handleSubmit,
    status,
  };
}
